export const config = {
  //Footer content
  location_1: "Yazbek Bldg, Dawar Jomblat, Abou Deib Road, Tyre",
  number_1: "+96103640520",
  email: "lamaanaligners@gmail.com",
  insta_1: "https://www.instagram.com/lamaanclinics?igsh=MzRlODBiNWFlZA==",
  linkedin_1: "https://linkedin.com/in/dr-maan-abadi-5a3a5283",
  healthflow: "https://healthflowonline.com",
  facebook_1: "https://www.facebook.com/share/18wejtNgyU/?mibextid=wwXIfr",
  // Navigation Header
  newsSection: true,
  aboutSection: true,
  servicesSection: true,
  AdditionalsSection: true,
  // Pages
  DoctorsPage: true,
  // OurPricingPage: true,
  MediaPage: true,
  OurServicesPage: true,
  ServiceDetailsPage: true,
};
